var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c(
        "form-wrapper",
        { staticClass: "modal-form", attrs: { validator: _vm.$v.rateDetail } },
        [
          _c("header", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "modal-header__right" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-simple md-just-icon md-round",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("clear")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c(
              "div",
              { staticClass: "section-override" },
              [
                _c(
                  "md-switch",
                  {
                    model: {
                      value: _vm.rateDetail.overrideRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.rateDetail, "overrideRule", $$v)
                      },
                      expression: "rateDetail.overrideRule",
                    },
                  },
                  [_vm._v("\n                   Override\n                ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Timeframe"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Choose when the rule is active."),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "section-card section-card--wide" },
              [
                _c("rule-valid-days", {
                  ref: "ruleValidDays",
                  attrs: {
                    "current-days": _vm.rateDetail.validForWeekDays,
                    "from-date": _vm.rateDetail.validFromDate,
                    "to-date": _vm.rateDetail.validToDate,
                  },
                  on: { daysSelected: _vm.handleDaysSeleceted },
                }),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Charging"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Set base charges, hourly rate and included time."),
              ]),
            ]),
            _c("div", { staticClass: "section-card section-card--compact" }, [
              _c("div", { staticClass: "charging-grid" }, [
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Base charges"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v(
                      "Flag fall and minimum charge prior to hourly billing."
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: { name: "hourlyFlagfall", label: "Flag Fall" },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.hourlyFlagfall)
                            ? _c("rule-operator", {
                                attrs: {
                                  value: _vm.rateDetail.hourlyFlagfall.operator,
                                },
                                model: {
                                  value: _vm.rateDetail.hourlyFlagfall.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.hourlyFlagfall,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.hourlyFlagfall.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.hourlyFlagfall.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.hourlyFlagfall,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.hourlyFlagfall.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "hourlyMinimumCharge",
                            label: "Minimum Charge",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.hourlyMinimumCharge)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.hourlyMinimumCharge.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.hourlyMinimumCharge.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.hourlyMinimumCharge,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.hourlyMinimumCharge.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.hourlyMinimumCharge.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.hourlyMinimumCharge,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.hourlyMinimumCharge.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "div",
                  { staticClass: "charging-group" },
                  [
                    _c("h5", { staticClass: "charging-group__title" }, [
                      _vm._v("Hourly rate"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Primary charge applied per hour, and time Adjustment (minutes)"
                      ),
                    ]),
                    _c(
                      "form-group",
                      {
                        attrs: {
                          name: "hourlyRatePerHour",
                          label: "Hourly Rate",
                        },
                      },
                      [
                        _vm.$_nullChecker(_vm.rateDetail.hourlyRatePerHour)
                          ? _c("rule-operator", {
                              attrs: {
                                value:
                                  _vm.rateDetail.hourlyRatePerHour.operator,
                              },
                              model: {
                                value:
                                  _vm.rateDetail.hourlyRatePerHour.operator,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rateDetail.hourlyRatePerHour,
                                    "operator",
                                    $$v
                                  )
                                },
                                expression:
                                  "rateDetail.hourlyRatePerHour.operator",
                              },
                            })
                          : _vm._e(),
                        _c("md-input", {
                          model: {
                            value: _vm.rateDetail.hourlyRatePerHour.value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rateDetail.hourlyRatePerHour,
                                "value",
                                _vm._n($$v)
                              )
                            },
                            expression: "rateDetail.hourlyRatePerHour.value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "form-group",
                      {
                        attrs: {
                          name: "hourlyTimeAdjustment",
                          label: "Time Adjustment",
                        },
                      },
                      [
                        _vm.$_nullChecker(_vm.rateDetail.hourlyTimeAdjustment)
                          ? _c("rule-operator", {
                              attrs: {
                                value:
                                  _vm.rateDetail.hourlyTimeAdjustment.operator,
                              },
                              model: {
                                value:
                                  _vm.rateDetail.hourlyTimeAdjustment.operator,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rateDetail.hourlyTimeAdjustment,
                                    "operator",
                                    $$v
                                  )
                                },
                                expression:
                                  "rateDetail.hourlyTimeAdjustment.operator",
                              },
                            })
                          : _vm._e(),
                        _c("md-input", {
                          model: {
                            value: _vm.rateDetail.hourlyTimeAdjustment.value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rateDetail.hourlyTimeAdjustment,
                                "value",
                                _vm._n($$v)
                              )
                            },
                            expression: "rateDetail.hourlyTimeAdjustment.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Inclusions"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v(
                      "Set included time (minutes) before additional hourly charges apply."
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "hourlyMinimumTime",
                            label: "Minimum Time",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.hourlyMinimumTime)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.hourlyMinimumTime.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.hourlyMinimumTime.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.hourlyMinimumTime,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.hourlyMinimumTime.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.hourlyMinimumTime.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.hourlyMinimumTime,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.hourlyMinimumTime.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "includedTime",
                            label: "Included Time",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.includedTime)
                            ? _c("rule-operator", {
                                attrs: {
                                  value: _vm.rateDetail.includedTime.operator,
                                },
                                model: {
                                  value: _vm.rateDetail.includedTime.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.includedTime,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.includedTime.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.includedTime.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.includedTime,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.includedTime.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Duration & rounding"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v(
                  "Select statuses that define duration and configure rounding rules."
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "section-card section-card--compact" },
              [
                _c(
                  "div",
                  { staticClass: "status-selector" },
                  [
                    _c("h6", { staticClass: "charging-group__title" }, [
                      _vm._v("Duration statuses"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Select exactly two statuses to calculate duration."
                      ),
                    ]),
                    _c("multiselect", {
                      attrs: {
                        options: _vm.statues,
                        multiple: true,
                        "close-on-select": false,
                        max: _vm.maxStatus,
                        placeholder: "Select up to two statuses",
                      },
                      model: {
                        value: _vm.rateDetail.hourlyStatuses,
                        callback: function ($$v) {
                          _vm.$set(_vm.rateDetail, "hourlyStatuses", $$v)
                        },
                        expression: "rateDetail.hourlyStatuses",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "status-selector" },
                  [
                    _c("h6", { staticClass: "charging-group__title" }, [
                      _vm._v("Rounding mode"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Choose how captured time is rounded when calculating charges."
                      ),
                    ]),
                    _c("multiselect", {
                      ref: "roundingModeContainer",
                      attrs: {
                        options: _vm.roundingOptions,
                        multiple: true,
                        "close-on-select": true,
                        placeholder: "Rounding mode",
                        label: "label",
                        "track-by": "label",
                        reduce: function (x) {
                          return x.key
                        },
                        max: 1,
                      },
                      model: {
                        value: _vm.selectedRoundingMode,
                        callback: function ($$v) {
                          _vm.selectedRoundingMode = $$v
                        },
                        expression: "selectedRoundingMode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "form-group",
                  {
                    attrs: {
                      name: "roudingTo",
                      label: "Rounding To (Minutes)",
                    },
                  },
                  [
                    _vm.isUpdate && _vm.updatingRule
                      ? _c("md-input", {
                          model: {
                            value: _vm.rateDetail.roundTo,
                            callback: function ($$v) {
                              _vm.$set(_vm.rateDetail, "roundTo", $$v)
                            },
                            expression: "rateDetail.roundTo",
                          },
                        })
                      : _vm._e(),
                    !_vm.isUpdate || !_vm.updatingRule
                      ? _c("md-input", {
                          model: {
                            value: _vm.rateDetail.roundTo,
                            callback: function ($$v) {
                              _vm.$set(_vm.rateDetail, "roundTo", _vm._n($$v))
                            },
                            expression: "rateDetail.roundTo",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("footer", { staticClass: "modal-footer" }, [
            _c(
              "div",
              { staticClass: "modal-footer__actions" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-default dialog-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary dialog-button",
                    on: {
                      click: function ($event) {
                        return _vm.create()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.isUpdate ? "Update" : "Create") +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }